import Table from "@mui/material/Table";
import { styled } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import {
  COLOR_BLACK,
  COLOR_GREEN,
  COLOR_GREY_2,
  COLOR_WHITE_40,
} from "shared/theme/colors";
import FlexCenter from "../Layout/components/FlexCenter";

export const StyledTable = styled(Table, {
  shouldForwardProp: (props) => props !== "loading",
})<{ loading: boolean }>`
  &.MuiTable-root {
    outline: none;
    border: none;
    display: block;
  }

  & .MuiTableCell-root {
    padding: 0 12px;
  }

  ${(props) =>
    props.loading &&
    `
      &::before {
        content: "";
        display: block;
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: ${COLOR_WHITE_40};
      }
  `}
`;

export const StyledSpinnerWrapper = styled(FlexCenter)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const StyledEmptyWrapper = styled(FlexCenter)`
  background-color: ${COLOR_GREY_2};
  height: 140px;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 1rem;
`;

export default makeStyles(() => ({
  noDataMessage: {
    "&.MuiAlert-root": {
      height: 58,
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      backgroundColor: COLOR_GREEN,
      color: COLOR_BLACK,
      fontWeight: 500,

      "& .MuiAlert-icon": {
        color: COLOR_BLACK,
        marginRight: "0.625rem",
      },
    },
  },
}));
